
export type SearchChatUsers200ContentItem = {
  /** @nullable */
  avatarUrl?: string | null;
  displayName: string;
  userId: string;
  userName: string;
};
